import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: -1rem 0 1rem -1rem;
`;
